// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_shared_sentry_ts":"70654872a7e601e7","src_app_search_search_module_ts":"796d46ce255789a3","src_app_library-list_library-list_module_ts":"2081c654064e8038","src_app_search_full-card_full-card_module_ts":"829a18ea9a388814"}[chunkId] + ".js";
};